import { AgGridReact } from 'ag-grid-react'
import React, { useState } from 'react'
import { Tooltip } from 'react-bootstrap'
import { Funnel, FunnelChart, LabelList, ResponsiveContainer } from 'recharts'

const Insights = () => {


    const [isShowsLoader, setIsShowsLoader] = useState(false);
      const [selectedTheme, setSelectedTheme] = useState('balham');
       const rawData = [
    { stage: 'Sent', value: 1245, fill: '#9279EC' }, // Blue
    { stage: 'Opened', value: 305, fill: '#7799E9' }, // Green
    { stage: 'Clicked', value: 87, fill: '#76E1AF' }, // Amber
    { stage: 'Replied', value: 65, fill: '#BFE6A2' }, // Red
  ];
    // Add percentage values
  const total = rawData[0].value;
  const data = rawData.map((item) => ({
    ...item,
    // label: `${item.stage} - ${item.value} (${((item.value / total) * 100).toFixed(1)}%)`,
    label: `${item.stage} - ${((item.value / total) * 100).toFixed(1)}% `,
  }));

   

  const [contactData] = useState([
      {
        contact: 'John Smith',
        email: 'john@techcorp.com',
        step: 'Step 2',
        status: 'Opened',
        lastAction: 'Email Opened',
        date: 'Dec 15, 2024',
      },
      {
        contact: 'Sarah Johnson',
        email: 'sarah@healthinc.com',
        step: 'Step 3',
        status: 'Replied',
        lastAction: 'Email Reply',
        date: 'Dec 14, 2024',
      },
      {
        contact: 'Mike Davis',
        email: 'mike@financegroup.com',
        step: 'Step 1',
        status: 'Pending',
        lastAction: 'Email Sent',
        date: 'Dec 16, 2024',
      },
    ]);
  
    const [contactColumnDefs] = useState([
      { headerName: 'Contact', field: 'contact', flex: 1 },
      { headerName: 'Email', field: 'email', flex: 1.5 },
      { headerName: 'Step', field: 'step', flex: 1 },
      {
        headerName: 'Status',
        field: 'status',
        flex: 1,
        cellRenderer: (params) => {
          const status = params.value;
          let color = '';
  
          switch (status.toLowerCase()) {
            case 'opened':
              color = '#d1fadf'; // green
              break;
            case 'replied':
              color = '#dbeafe'; // blue
              break;
            case 'pending':
              color = '#fef3c7'; // yellow
              break;
            default:
              color = '#f3f4f6'; // fallback
          }
  
          return (
            <span
              style={{
                backgroundColor: color,
                padding: '0px 10px',
                borderRadius: '12px',
                fontSize: '12px',
                display: 'inline-block',
                textTransform: 'capitalize',
                fontWeight: 500,
                lineHeight: '18px',
              }}
            >
              {status}
            </span>
          );
        },
      },
      { headerName: 'Last Action', field: 'lastAction', flex: 1.5 },
      { headerName: 'Date', field: 'date', flex: 1 },
    ]);
     const [rowData] = useState([
        {
          step: 'Step 1: Initial Outreach',
          sent: 1245,
          opens: '305 (24.5%)',
          clicks: '87 (7.0%)',
          replies: '42 (3.4%)',
        },
        {
          step: 'Step 2: Follow-up Email',
          sent: 892,
          opens: '201 (22.5%)',
          clicks: '34 (3.8%)',
          replies: '18 (2.0%)',
        },
        {
          step: 'Step 3: Final Touch',
          sent: 634,
          opens: '95 (15.0%)',
          clicks: '12 (1.9%)',
          replies: '5 (0.8%)',
        },
      ]);
       const [columnDefs] = useState([
          { headerName: 'Step', field: 'step', flex: 2 },
          { headerName: 'Sent', field: 'sent', flex: 1 },
          { headerName: 'Opens', field: 'opens', flex: 1 },
          { headerName: 'Clicks', field: 'clicks', flex: 1 },
          { headerName: 'Replies', field: 'replies', flex: 1 },
        ]);
  return (
                <div
                  
                >
                  <div className="row">
                    <div className="col-12 col-sm-12 col-md-5 col-lg-5">
                      <div className="hdrInsights ">
                        <h2>Email Funnel Performance</h2>
                      </div>
                      <div className="whBlock">
                        <div
                          style={{
                            width: '100%',
                            height: '270px',
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <ResponsiveContainer>
                            <FunnelChart>
                              <Tooltip
                                formatter={(value, name, props) => [
                                  `${value} (${((value / total) * 100).toFixed(1)}%)`,
                                  'Count',
                                ]}
                                contentStyle={{
                                  backgroundColor: '#fff',
                                  border: '1px solid #dee2e6',
                                  borderRadius: '0.5rem',
                                }}
                                itemStyle={{ color: '#000' }}
                              />
                              <Funnel dataKey="value" data={data} isAnimationActive shape="rect">
                                <LabelList
                                  dataKey="label"
                                  position="right"
                                  style={{ fill: '#000', fontSize: 14 }}
                                />
                              </Funnel>
                            </FunnelChart>
                          </ResponsiveContainer>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-7 col-lg-7">
                      <div className="hdrInsights ">
                        <h2>Step-wise Performance</h2>
                        <button className="btn btn-outline-primary mobOption ">
                          {' '}
                          <svg
                            width="16px"
                            height="16px"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 5L11.2929 4.29289L12 3.58579L12.7071 4.29289L12 5ZM13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14L13 14ZM6.29289 9.29289L11.2929 4.29289L12.7071 5.70711L7.70711 10.7071L6.29289 9.29289ZM12.7071 4.29289L17.7071 9.29289L16.2929 10.7071L11.2929 5.70711L12.7071 4.29289ZM13 5L13 14L11 14L11 5L13 5Z"
                              fill="#3a5afe"
                            />
                            <path
                              d="M5 16L5 17C5 18.1046 5.89543 19 7 19L17 19C18.1046 19 19 18.1046 19 17V16"
                              stroke="#3a5afe"
                              strokeWidth="2"
                            />
                          </svg>{' '}
                          Export Matrics
                        </button>
                      </div>
                      <div className="tableblk p-0">
                        <div className="dsk">
                          <div
                            className={`ag-theme-${selectedTheme} tbl_height`}
                            style={{ width: '100%', height: `calc(100vh - 400px)` }}
                          >
                            <AgGridReact
                              rowData={rowData}
                              columnDefs={columnDefs}
                              domLayout="fixedHeight"
                            />
                          </div>
                        </div>
                        <div className="card-text mob">
                          <div className="myTicketBlock">
                            {isShowsLoader ? (
                              <div style={{ textAlign: 'center' }}>
                                <div className="loader"></div> Loading...
                              </div>
                            ) : rowData && rowData.length > 0 ? (
                              rowData.map((intLog, index) => (
                                <div key={index} className="myTicketOuterBlock">
                                  <div className="myTicketInner">
                                    <p>{intLog.step}</p>
                                  </div>
                                  <div className="myTicketInner statusBlock">
                                    <div className="tktStats">
                                      <p>Sent</p>
                                      <span>{intLog.sent}</span>
                                    </div>
                                    <div className="tktStats">
                                      <p>Opens</p>
                                      <span>{intLog.opens}</span>
                                    </div>
                                  </div>
                                  <div className="myTicketInner statusBlock">
                                    <div className="tktStats">
                                      <p>Clicks</p>
                                      <span>{intLog.clicks}</span>
                                    </div>
    
                                    <div className="tktStats">
                                      <p>Replies</p>
                                      <span>{intLog.replies}</span>
                                    </div>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className="noDataBlock">
                                <div className="NodataContent">
                                  <img src="../assets/images/empty-box.png" alt="" />
                                  <p>No Intraction Log Available.</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                      <div className="hdrInsights mt-3">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label className="form-check-label mb-0" for="flexCheckDefault">
                            Show detailed contact interactions
                          </label>
                        </div>
                      </div>
                      <div className="frmHdr ">
                        <h2>Contact-Level Interaction Log</h2>
                      </div>
    
                      <div className="tableblk pt-3 px-0 pb-0">
                        <div className="dsk">
                          <div
                            className={`ag-theme-${selectedTheme} tbl_height`}
                            style={{ width: '100%', height: `calc(100vh - 400px)` }}
                          >
                            <AgGridReact
                              rowData={contactData}
                              columnDefs={contactColumnDefs}
                              domLayout="fixedHeight"
                            />
                          </div>
                        </div>
                        <div className="card-text mob">
                          <div className="myTicketBlock">
                            {isShowsLoader ? (
                              <div style={{ textAlign: 'center' }}>
                                <div className="loader"></div> Loading...
                              </div>
                            ) : contactData && contactData.length > 0 ? (
                              contactData.map((intLog, index) => (
                                <div key={index} className="myTicketOuterBlock">
                                  <div className="myTicketInner">
                                    <small className="steps">{intLog.step}</small>
                                    <p>{intLog.contact}</p>
                                    <span className="subjectName">{intLog.email}</span>
                                  </div>
                                  <div className="myTicketInner statusBlock">
                                    <div className="active">
                                      <span className="dotsactive"></span>
                                      <span>{intLog.status}</span>
                                    </div>
                                    <div className="highpriority">
                                      <span>{intLog.lastAction}</span>
                                    </div>
                                  </div>
    
                                  <div className="myTicketInner">
                                    <span className="dateBlk">{intLog.date}</span>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className="noDataBlock">
                                <div className="NodataContent">
                                  <img src="../assets/images/empty-box.png" alt="" />
                                  <p>No Intraction Log Available.</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
             
  )
}

export default Insights